<template>
  <div v-if="!isCookieFlagSet()" class="cookie-bar">
    <div class="container">
      <div>
        Autopay korzysta z plików cookie. Pozostając na tej stronie, wyrażasz zgodę na korzystanie z plików
        cookie zgodnie z <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Polityką&nbsp;prywatności Autopay&nbsp;S.A.</a>
        Możesz samodzielnie zarządzać cookies zmieniając odpowiednio ustawienia swojej przeglądarki lub oprogramowania urządzenia.
      </div>
      <button title="Zamknij" @click="setCookieFlag">Zamknij</button>
    </div>
  </div>
</template>

<script>
import TopupCookieMixin from '@/common/mixins/Topup/Cookie.mixin'
export default {
  name: 'Cookie',
  mixins: [TopupCookieMixin]
}
</script>

<style lang="scss" src="../assets/scss/cookie.scss" scoped></style>
